import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import { Placeholder } from '@tiptap/extensions';
import { PsTextColorExtension } from '../extensions/PsTextColorExtension.js';
import PsHighlightExtension from '../extensions/PsHighlightExtension.js';
import { FontFamilyClassExtension } from '../extensions/FontFamilyClassExtension.js';
import { POST_EDITOR_DISABLED_STARTER_KIT_MARKS } from './post_editor_constants.js';

const CaptionDocument = Document.extend({
  content: 'paragraph',
});

/**
 * Minimal TipTap schema for carousel slide captions: one paragraph, inline marks
 * aligned with image/video caption tooling (links, color, font, highlight, etc.).
 */
export function getCarouselCaptionEditorExtensions() {
  return [
    StarterKit.configure({
      ...POST_EDITOR_DISABLED_STARTER_KIT_MARKS,
      document: false,
      blockquote: false,
      bulletList: false,
      orderedList: false,
      listItem: false,
      listKeymap: false,
      codeBlock: false,
      heading: false,
      horizontalRule: false,
      trailingNode: false,
      link: {
        openOnClick: false,
        autolink: true,
        HTMLAttributes: {
          class: 'tiptap-link',
        },
      },
    }),
    CaptionDocument,
    Subscript,
    Superscript,
    FontFamilyClassExtension,
    PsTextColorExtension,
    PsHighlightExtension,
    Placeholder.configure({
      placeholder: 'Add Caption here',
      showOnlyWhenEditable: true,
      showOnlyCurrent: true,
    }),
  ];
}
